import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

import {
    ENV_SHAPE_PROP_TYPE,
    FOOTER_LINKS_SHAPE_PROP_TYPE,
    REQUEST_SHAPE_PROP_TYPE,
    SiteStructure,
    USER_SHAPE_PROP_TYPE,
} from '@eb/site-structure';
import { NotificationBar } from '@eb/eds-notification';
import { TYPE_WARNING } from '@eb/eds-notification';
import { trackAnalyticsEvent } from '@eb/site-analytics';
import { gettext } from '@eventbrite/i18n';

import {
    GA_ACTION_PROFILE_DROPDOWN,
    GA_CATEGORY_HEADER,
    GA_LABEL_CREATOR_EVENT,
} from '../constants/analytics';
import { getIndependentScrolling } from './utils';
import { scrollToTop } from '../components/utils';
import './page.scss';

const Covid19Notification = () => (
    <NotificationBar
        type={TYPE_WARNING}
        onCallAction={() => null}
        callAction={
            <a href="/l/coronavirus-resources-event-organizers/">
                {gettext('Learn more')}
            </a>
        }
    >
        {gettext(
            'Communities around the world are feeling the effects of the coronavirus (COVID-19) on their live experiences. We’re here to help in any way we can.',
        )}
    </NotificationBar>
);

class MarketingPage extends PureComponent {
    static propTypes = {
        env: ENV_SHAPE_PROP_TYPE.isRequired,
        request: REQUEST_SHAPE_PROP_TYPE.isRequired,
        user: USER_SHAPE_PROP_TYPE.isRequired,
        footerLinks: FOOTER_LINKS_SHAPE_PROP_TYPE.isRequired,
        children: PropTypes.node,
    };

    constructor(props) {
        super(props);
        const hasIndependentScrolling = getIndependentScrolling(props);

        this.state = {
            hasIndependentScrolling,
        };
    }

    UNSAFE_componentWillReceiveProps(props) {
        const hasIndependentScrolling = getIndependentScrolling(props);

        scrollToTop();

        this.setState({
            hasIndependentScrolling,
        });
    }

    render() {
        const {
            env,
            request,
            user,
            footerLinks,
            children,
            router: { location: { pathname } } = {},
            featureFlags,
        } = this.props;
        const { hasIndependentScrolling } = this.state;

        const covidNotification = <Covid19Notification />;
        const onTrackingUserDropdown = () => {
            trackAnalyticsEvent({
                action: GA_ACTION_PROFILE_DROPDOWN,
                category: GA_CATEGORY_HEADER,
                label: GA_LABEL_CREATOR_EVENT,
            });
        };

        return (
            <SiteStructure
                env={env}
                request={request}
                user={user}
                footerLinks={footerLinks}
                showMarketingLinks={true}
                fullScreenMain={true}
                hasIndependentScrolling={hasIndependentScrolling}
                onMouseEnterGlobalHeader={onTrackingUserDropdown}
            >
                {covidNotification}
                {children}
            </SiteStructure>
        );
    }
}

export default withRouter(MarketingPage);
